import { render, staticRenderFns } from "./DefectCollectionSettingsForm.vue?vue&type=template&id=7cef3927&"
import script from "./DefectCollectionSettingsForm.vue?vue&type=script&lang=js&"
export * from "./DefectCollectionSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports